import { render } from "./LandRate.vue?vue&type=template&id=80512316&scoped=true"
import script from "./LandRate.vue?vue&type=script&lang=js"
export * from "./LandRate.vue?vue&type=script&lang=js"

import "./LandRate.vue?vue&type=style&index=0&id=80512316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80512316"]])

export default __exports__